(function (window) {
  'use strict';

  var submissions = new WeakMap();
  var failureMessage = 'Text signup did not complete. Please try again.';

  function createUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }

    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;

    var hex = Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    });

    return (
      hex.slice(0, 4).join('') +
      '-' +
      hex.slice(4, 6).join('') +
      '-' +
      hex.slice(6, 8).join('') +
      '-' +
      hex.slice(8, 10).join('') +
      '-' +
      hex.slice(10, 16).join('')
    );
  }

  function buildPayload(form, phoneNumber, email) {
    var payload = {
      phone_number: phoneNumber,
      form_id: form.id || '',
      signup_source: form.dataset.source || '',
      page_location: window.location.href,
      attentive_signup_source_id: form.dataset.attentiveSignupSourceId,
      attentive_resubscribe: false,
      sms_consent: true,
      submission_id: createUuid(),
    };

    if (email) {
      payload.email = email;
    }
    if (form.dataset.attentiveProfileAttribute) {
      payload.attentive_profile_attribute = form.dataset.attentiveProfileAttribute;
    }
    if (form.dataset.attentiveAlreadySubscribedMessage) {
      payload.attentive_already_subscribed_message = form.dataset.attentiveAlreadySubscribedMessage;
    }

    return payload;
  }

  function createFailure() {
    return new Error(failureMessage);
  }

  function normalizePhone(value) {
    var phoneValue = String(value || '').trim();
    if (!phoneValue || /[^0-9\s()+.-]/.test(phoneValue)) {
      return '';
    }

    var digits = phoneValue.replace(/\D/g, '');

    if (digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.slice(1);
    }

    if (digits.length !== 10) {
      return '';
    }

    return '+1' + digits;
  }

  function submit(form, normalizedPhone, optionalEmail) {
    var submittedPhone = String(normalizedPhone || '').trim();
    var signupSourceId = form && form.dataset ? String(form.dataset.attentiveSignupSourceId || '').trim() : '';

    if (!form || !submittedPhone || !signupSourceId) {
      return Promise.resolve({ ok: true, skipped: true });
    }

    var phoneNumber = normalizePhone(submittedPhone);
    if (!phoneNumber) {
      return Promise.reject(createFailure());
    }

    if (submissions.has(form)) {
      return submissions.get(form);
    }

    var email = String(optionalEmail || '').trim();
    var payload = buildPayload(form, phoneNumber, email);
    var request = window
      .fetch('/apps/dev-tools/attentive-sms', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            throw createFailure();
          })
          .then(function (result) {
            if (!response.ok || !result || result.ok === false) {
              throw createFailure();
            }
            return result;
          });
      })
      .catch(function () {
        submissions.delete(form);
        throw createFailure();
      });

    submissions.set(form, request);
    return request;
  }

  window.DieuxAttentiveSms = {
    normalizePhone: normalizePhone,
    submit: submit,
  };
})(window);
